"use client";

import { getMenuPromotionsAction } from "@/lib/shop/shop-actions";
import { ShopMenuPromotion } from "@/lib/shop/shop-types";
import { useQuery } from "@tanstack/react-query";
import MenuPromotionCarousel from "./menu-promotions-carousel";

type MenuPromotionsClientProps = {
    state: string;
    supplierIDs?: number[];
    showTitle?: boolean;
};

export default function ShopPageMenuPromotions({
    state,
    supplierIDs,
    showTitle = true
}: MenuPromotionsClientProps) {
    const {
        data: menuPromotions = [],
        isPending,
        error
    } = useQuery<ShopMenuPromotion[]>({
        queryKey: ["menuPromotions", state, supplierIDs],
        queryFn: () => getMenuPromotionsAction(state, supplierIDs),
        staleTime: 15 * 60 * 1000, // 15 minutes
        gcTime: 30 * 60 * 1000, // 30 minutes
        retry: 2,
        refetchOnWindowFocus: false
    });

    if (error || isPending || menuPromotions.length === 0) {
        return null;
    }

    return <MenuPromotionCarousel menuPromotions={menuPromotions} showTitle={showTitle} />;
}
